<template>
  <v-app id="inspire">
    <section>
      <v-parallax src="assets/section.jpg" height="380">
        <v-layout column align-center justify-center>
          <div class="headline primary--text mb-3 text-xs-center">仮登録完了</div>
          <em class="grey--text darken-4">
            仮登録が完了しました。<br>
            ご登録いただきましたメールアドレスに、「会員登録のご確認」のお知らせをお送り致しました。<br>
            そちらに記載のURLにアクセスして、本会員登録を完了してください。
            仮登録メール「会員登録のご確認」を受信しない場合は、下記の事項をご確認のうえ、改めて新規登録をお試しください。<br>
            【ご確認事項】<br>
            １）ご利用の端末で受信設定をしている場合は、「@withm.net 」からのメールを受信できるように設定してください。<br>
            ２）ご利用のメールソフトの迷惑メールフォルダ等に、振り分けられていないかご確認ください。<br>
            ３）正しいメールアドレスをご入力いただいているか、ご確認ください。
          </em>
          <v-btn
            class="primary mt-5"
            dark
            large
            href="/"
          >
            トップページへ
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>
  </v-app>
</template>

<script>
export default {
  name: 'RegisterConfirm'
}
</script>

<style lang="scss" scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/RegisterConfirm.vue